import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('terms.title')}
        url="https://band-space.com/terms/"
        canonical="https://band-space.com/terms/"
      />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('terms.title', 'Terms & Conditions')}
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              {t('terms.lastUpdated', 'Last Updated: March 2024')}
            </Typography>

            <Typography variant="body1" paragraph>
              {t('terms.introduction', 'Welcome to Band Space. By using our platform, you agree to these terms and conditions.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.usage', '1. Usage of Service')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.usageContent', 'Band Space provides a platform for booking rehearsal spaces. Users must be at least 18 years old to use our services.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.bookings', '2. Booking and Cancellations')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.bookingsContent', 'Bookings are subject to availability. Cancellation policies vary by space and are clearly stated during the booking process.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.conduct', '3. User Conduct')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.conductContent', 'Users must respect the spaces they book and follow all posted rules. Any damage to property will be the responsibility of the booking party.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.calendarIntegration', '4. Integration with Google Calendar')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t(
                'terms.calendarIntegrationContent',
                'If you choose to connect your Google Calendar account to Band Space, we will request permission to create and manage events on your behalf using the Google Calendar API. This allows us to create, update, or delete rehearsal booking events directly in your calendar. You can revoke access at any time via your Google Account permissions.'
              )}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.privacy', '5. Privacy')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.privacyContent', 'We collect and process personal data in accordance with our Privacy Policy. By using our service, you consent to such processing, including access to your Google Calendar if you connect it to your account.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.liability', '6. Limitation of Liability')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.liabilityContent', 'Band Space is not liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('terms.changes', '7. Changes to Terms')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('terms.changesContent', 'We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.')}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default TermsPage; 